import { useState } from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { useApi, publicApi } from "../hooks/useApi";
import { useUser } from "../hooks/useAuthCompat";
import { usePlayer } from "../context/PlayerContext";
import { Play } from "lucide-react";

export default function Listen() {
  const api = useApi();
  const { isSignedIn } = useUser();
  const { play } = usePlayer();
  const [q, setQ] = useState("");
  const { data: episodes, isLoading } = useQuery({
    queryKey: ["episodes", q],
    queryFn: async () => (await publicApi.get(`/episodes?limit=60${q ? `&q=${encodeURIComponent(q)}` : ""}`)).data,
  });

  const playEpisode = (ep) => {
    play({ id: ep.id, title: ep.title, subtitle: "Episode", image: ep.image_url, audioUrl: ep.audio_url });
    if (isSignedIn) api.post(`/episodes/${ep.id}/history?position_seconds=0`).catch(() => {});
  };

  return (
    <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-16" data-testid="listen-page">
      <p className="text-xs uppercase tracking-[0.2em] text-textSecondary mb-2">Listen</p>
      <h1 className="font-display text-display-md md:text-display-lg font-medium mb-8">The ENDURE BEYOND Podcast</h1>
      <input
        data-testid="listen-search-input"
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder="Search episodes by title…"
        className="bg-white/5 border border-white/15 px-4 py-3 w-full max-w-md mb-10 focus:outline-none focus:ring-2 focus:ring-white/40"
      />
      {isLoading && <p className="text-white/70">Loading episodes…</p>}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        {episodes?.map((ep) => (
          <Link to={`/listen/${ep.id}`} key={ep.id} className="flex gap-4 bg-surface border border-border p-4 hover:border-white/30 transition-colors duration-200" data-testid={`episode-card-${ep.id}`}>
            <img src={ep.image_url} alt="" className="w-20 h-20 object-cover shrink-0" />
            <div className="min-w-0 flex-1">
              <p className="text-sm hover:text-brandAccent line-clamp-2">{ep.title}</p>
              <p className="text-[11px] text-white/60 mt-2">{ep.pub_date}</p>
            </div>
            <button
              data-testid={`episode-play-button-${ep.id}`}
              onClick={(e) => { e.preventDefault(); playEpisode(ep); }}
              className="self-center w-9 h-9 flex items-center justify-center bg-white text-black shrink-0"
            >
              <Play className="w-4 h-4 ml-0.5" />
            </button>
          </Link>
        ))}
      </div>
    </div>
  );
}
